import { Pipe, PipeTransform } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Location } from 'src/app/core/models/project/location.model';
import { Setting } from 'src/app/core/models/project/setting.model';

@Pipe({
  name: 'reversedCommunicationAccessControlExistsInProject'
})
export class ReversedCommunicationAccessControlExistsInProjectPipe implements PipeTransform {

  transform(locations: Location[]): boolean {
    return locations.some((l: Location)=> {
      return l.controllers.$values.some((controller: Controller)=> {
        return controller.controllerSettings.$values.some((sett: Setting )=> {
                return sett.name === 'ReversedCommunication' && sett.value === '1'
              })
      })
    });
  }

}
